import type { Permission, WorkspacePermission } from '../Types'

/**
 * 指定した権限を保有しているかどうかを確認する
 *
 * @param permissions
 * @param action
 * @param resource
 * @return boolean もし権限を持っている場合 true を返す
 */
export const hasHomePermission = (
  permissions: Permission[] = [],
  action,
  resource,
) => {
  return Array.isArray(permissions)
    ? permissions.some(
        (permission) =>
          permission.action === action && permission.name === resource,
      )
    : false
}

/**
 * 指定した権限を保有しているかどうかを確認する
 *
 * @param siteId
 * @param permissions
 * @param action
 * @param resource
 * @return boolean もし権限を持っている場合 true を返す
 */
export const hasPermission = (
  siteId,
  permissions: Permission[] = [],
  action,
  resource,
) => {
  return Array.isArray(permissions)
    ? permissions.some(
        (permission) =>
          permission.action === action &&
          permission.name === resource &&
          permission.site_id === siteId,
      )
    : false
}

/**
 * 指定した権限を保有しているかどうかを確認する
 *
 * @param permissions
 * @param action
 * @param resource
 * @param options
 * @return boolean もし権限を持っている場合 true を返す
 */
export const hasPostPermission = (
  permissions: Permission[] = [],
  action: string,
  postTypeId: number,
) => {
  return Array.isArray(permissions)
    ? permissions.some(
        (permission) =>
          permission.action === action &&
          permission.is_post_permission &&
          permission.post_type_id === postTypeId,
      )
    : false
}

/**
 * 指定した権限を保有しているかどうかを確認する
 *
 * @param permissions
 * @param action
 * @param resource
 * @return boolean もし権限を持っている場合 true を返す
 */
export const hasWorkspacePermission = (
  permissions: WorkspacePermission[] = [],
  action,
  resource,
) => {
  return Array.isArray(permissions)
    ? permissions.some(
        (permission) =>
          permission.workspace_permission_group_id != undefined &&
          permission.action === action &&
          permission.name === resource,
      )
    : false
}
